import { useQuery } from '@tanstack/react-query'

import { campaignCompaniesFromServer, getCampaignCompaniesQuery } from 'models/campaign-companies-model'
import { get } from 'utils/http'

// Campaign companies list (self-fetches now — removed from the fetchCampaign fan-out).
export const useCampaignCompanies = (id: any, meta: any) =>
  useQuery({
    queryKey: ['campaignCompanies', id, meta],
    queryFn: async () => {
      const { count, companies } = await get<{ count: number; companies: any[] }>(
        `/management/campaigns/${id}/companies`,
        { query: getCampaignCompaniesQuery(meta) },
      )
      return { count, items: (companies || []).map(campaignCompaniesFromServer) }
    },
    enabled: !!id,
  })
